import React from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { LayoutDashboard, FileText, TrendingUp, Sparkles, Bell, Package, Gift, Users, CalendarClock, Receipt } from "lucide-react";
import { useAuth } from "@/lib/auth";

const PARENT_LINKS = [
  { to: "/panel", label: "Genel Bakış", icon: LayoutDashboard, end: true },
  { to: "/panel/cocuklarim", label: "Çocuklarım", icon: Users },
  { to: "/panel/basvurularim", label: "Bursluluk Başvuruları", icon: FileText },
  { to: "/panel/performans", label: "Performans", icon: TrendingUp },
  { to: "/panel/davetler", label: "Davetler & Teklifler", icon: LayoutDashboard },
  { to: "/panel/gorusmelerim", label: "Görüşmelerim", icon: CalendarClock },
  { to: "/panel/tercih-danismanligi", label: "Tercih Danışmanlığı", icon: Sparkles },
  { to: "/panel/aboneligim", label: "Aboneliğim", icon: Package },
  { to: "/panel/odemelerim", label: "Ödemelerim", icon: Receipt },
  { to: "/panel/referans", label: "Referans Ödülü", icon: Gift },
  { to: "/panel/bildirimler", label: "Bildirim Ayarları", icon: Bell },
];

// Student self-service: no "Çocuklarım" (they are the student), no application flow
// gated to parent yet — hide items that call parent-only endpoints.
const STUDENT_LINKS = [
  { to: "/panel", label: "Genel Bakış", icon: LayoutDashboard, end: true },
  { to: "/panel/performans", label: "Performansım", icon: TrendingUp },
  { to: "/panel/tercih-danismanligi", label: "Tercih Danışmanlığı", icon: Sparkles },
  { to: "/panel/aboneligim", label: "Aboneliğim", icon: Package },
  { to: "/panel/odemelerim", label: "Ödemelerim", icon: Receipt },
  { to: "/panel/referans", label: "Referans Ödülü", icon: Gift },
  { to: "/panel/bildirimler", label: "Bildirim Ayarları", icon: Bell },
];

export default function ParentLayout() {
  const { user } = useAuth();
  const links = user?.role === "student" ? STUDENT_LINKS : PARENT_LINKS;
  const title = user?.role === "student" ? "Öğrenci Paneli" : "Veli Paneli";
  return <DashboardLayout links={links} title={title} testIdPrefix="parent-sidebar" />;
}
